/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Name/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Name({
  children,
  viewPath = "/DesignSystem/DataVaxiomInsuranceCarrierForm/Name",
  isInvalid,
  onChange
  
}) {
let carrierCarrierNameValueData = fromData.useDataValue({ viewPath,
context: 'carrier',
path: 'carrier_name',
})
let carrierCarrierNameIsValidData = fromData.useDataIsValid({ viewPath,
context: 'carrier',
path: 'carrier_name',
validate: fromValidate.textInput,
required: true,
})
let carrierCarrierNameChangeData = fromData.useDataChange({ viewPath,
context: 'carrier',
path: 'carrier_name',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="carrier.carrier_name"
 validate="/Data/validate.js textInput"
 invalid={!carrierCarrierNameIsValidData}
 required={true}
 value={carrierCarrierNameValueData}
 onChange={carrierCarrierNameChangeData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Name"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}